import createAxiosConfig from "../../config/createAxiosConfig";
import store from "../../config/store";
import encrypt from "../../utils/encrypt";

class LoginService {
  constructor() {
    this.urlBase = "/auth";
    this.urlBaseEvent = `/event${this.urlBase}`;
    this.axiosConfig = createAxiosConfig(store.baseUrl);
  }

  async logar(emailSenha, tokenRecaptcha) {
    const basicAuth = encrypt(emailSenha);
    const body = { basicAuth, tokenRecaptcha };
    return this.axiosConfig
      .post(`${this.urlBaseEvent}/login`, body)
      .then((reponse) => reponse)
      .catch((erro) => erro);
  }

  async gerarCodigoRecuperacaoSenha(email) {
    const body = {
      email,
    };
    return this.axiosConfig
      .post(`${this.urlBaseEvent}/recuperar-senha/gerar-codigo`, body)
      .then((reponse) => reponse)
      .catch((erro) => erro);
  }

  async validarCodigoRecuperacaoSenha(email, codigo) {
    const body = {
      email,
      codigo,
    };
    return this.axiosConfig
      .post(`${this.urlBaseEvent}/recuperar-senha/validar-codigo`, body)
      .then((reponse) => reponse)
      .catch((erro) => erro);
  }
}

export default LoginService;
